const PurchaseComplete = ({
  logo,
  logoAlt,
  brandName,
  csNumber = "1833-3503",
  onConfirm,
}) => {
  return (
    <div className="purchase-complete-page">
      <div className="purchase-complete-container">
        <div className="purchase-logo">
          <img src={logo} alt={logoAlt} />
        </div>
        <div className="purchase-content">
          <h2 className="purchase-title">구매 완료</h2>
          <p className="purchase-description">
            등록된 배송지로 {brandName}이 발송됩니다.
            <br />
            문의 사항은 아래 고객센터로 연락주시기 바랍니다.
            <br />
            감사합니다.
          </p>
          <div className="customer-service">
            <h3 className="cs-title">대표 고객센터</h3>
            <div className="cs-number">{csNumber}</div>
          </div>
          <button className="confirm-button" onClick={onConfirm}>
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default PurchaseComplete;
